import axios from "axios";

export const state = {
    crbreports: [],
};

export const getters = {
    crbreports: state => state.crbreports,
};

export const mutations = {
    setCrbReports(state, newValue) {
        state.crbreports = newValue
    },
};

export const actions = {
    async fetchCrbReports({ commit }) {
        await axios.get("/crb-reports").then(res => {
            commit('setCrbReports', res.data.crb_reports)
        })
    },
};
